import { BehaviorSubject } from "rxjs";
import { BottomBarFeatures } from "src/models/BottomBarFeatures";
import { CurrentUIState } from "src/models/UIState";

export class BottomBarBase {
    protected tabId: string;
    protected get hiddenFeatures(): BottomBarFeatures[] {
        return [];
    };
    private uiState: BehaviorSubject<CurrentUIState> = new BehaviorSubject<CurrentUIState>(new CurrentUIState(BottomBarFeatures));

    constructor(tabId: string) {
        this.tabId = tabId;
        this.setBottomBarFeaturesHidden();
    }

    getUIState() {
        return this.uiState.asObservable();
    }

    setSpellCheckerStatus(status: boolean) {
        const current = this.uiState.getValue();

        if (status) {
            current.showFeautre(BottomBarFeatures.SPELL_CHECKER_PROCESSING_STATUS);
        } else {
            current.hideFeautre(BottomBarFeatures.SPELL_CHECKER_PROCESSING_STATUS);
        }
    }

    setAudioMakerStatus(status: boolean) {
        const current = this.uiState.getValue();

        if (status) {
            current.showFeautre(BottomBarFeatures.AUDIO_MAKER_SELECTION_COUNTER);
        } else {
            current.hideFeautre(BottomBarFeatures.AUDIO_MAKER_SELECTION_COUNTER);
        }
    }

    setFeaturesDisabled(features: BottomBarFeatures[]) {
        const current = this.uiState.getValue();
        current.setListOfFeaturesDisabled(features);
        this.uiState.next(current);
    }

    setFeaturesEnabled(features: BottomBarFeatures[]) {
        const current = this.uiState.getValue();
        current.enableListOfFeatures(features);
        this.uiState.next(current);
    }

    setFeaturesActive(features: BottomBarFeatures[]) {
        const current = this.uiState.getValue();
        current.setListOfFeaturesActive(features);
        this.uiState.next(current);
    }

    setFeaturesUnActive(features: BottomBarFeatures[]) {
        const current = this.uiState.getValue();
        current.setListOfFeaturesUnActive(features);
        this.uiState.next(current);
    }

    setFeaturesHidden(features: BottomBarFeatures[]) {
        const current = this.uiState.getValue();
        current.setListOfFeatruesHidden(features);
        this.uiState.next(current);
    }


    async toggleThumbsList() { }
    togglePanes() { this.setFeaturesUnActive([BottomBarFeatures.TOGGLE_THUMBNAILS]); }
    async goToFirstPage() { }
    async goToPrevPage() { }
    async goToNextPage() { }
    async goToLastPage() { }
    async addZoom() { }
    async removeZoom() { }
    async setZoomLevel(_val) { }
    async setFitMode(_mode) { }
    async setLayoutMode(_mode) { }
    async rotateCounterClockwise() { }
    async rotateClockwise() { }

    private setBottomBarFeaturesHidden() {
        const current = this.uiState.getValue();
        current.setListOfFeatruesHidden(this.hiddenFeatures);
        this.uiState.next(current);
    }
}